
<script>
import bus from "@/bus";

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: 0,
      message: "",
    };
  },
  created() {
    this.status = this.params.status || 0;
    this.message = this.params.data.message || "";
  },
  methods: {
    close() {
      bus.emit("closeModal");
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <header class="p-2 text-center">
      <span>{{ $t("views.modals.error") }}</span>
      <span class="text-xl font-medium">{{ params.status }}</span>
    </header>
    <div class="p-4 border-t-2 border-solid border-gray-300">
      <span>{{ $t(params.data.message) }}</span>
    </div>
  </div>
</template>
